    <vg-player (onPlayerReady)="onPlayerReady($event)">
        <vg-buffering *ngIf="showBuffering"></vg-buffering>
        <vg-overlay-play *ngIf="showOverlayPlay" ></vg-overlay-play>
        <vg-controls>
            <vg-play-pause *ngIf="showPlayPause"></vg-play-pause>
            <vg-playback-button *ngIf="showPlaybackButton"></vg-playback-button>

            <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
            <button class="backward" (click)="seek(true)" *ngIf="showBackwardSeek"></button>
            <vg-scrub-bar *ngIf="showScrubBar">
                <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
            </vg-scrub-bar>
            <button class="forward" (click)="seek(false)" *ngIf="showForwardSeek"></button>
            <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

            <vg-mute *ngIf="showMute"></vg-mute>
            <vg-volume *ngIf="showVolume"></vg-volume>

    <!--        <div (click)="fullScreen()" *ngIf="showFullScreen">full </div>-->
            <vg-fullscreen ></vg-fullscreen>
        </vg-controls>

        <video #media [vgMedia]="media" id="singleVideo" preload="auto" crossorigin>
            <source src="{{blobUrl}}" type="video/mp4">
        </video>
    </vg-player>



